import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

const base_api_url = "KoranKiriman";
// const primaryKeys = ['customer_id', 'tgl1', 'tgl2', 'nofaktur', 'createby', 'code', 'name', 'customer_group', 'campaignKey', 'codenama', 'salesae_codename', 'collector_codename'];

export default {
    
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir','customer_id', 'CustCode', 'CustName', 'inclsubagen','tgl1', 'tgl2', 'nofaktur', 'createby', 'kota_id', 'kota_name', 'area_id', 'area_name', 'kiriman_code','kiriman_name', 'kirimanKeys', 'jurusan_id', 'jurusan_name', 'salesae_id', 'salesae_name','paid'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                if(obj.kirimanKeys){
                    obj.kirimanKeys.forEach(element => {
                        str += str ? '&' : '?';
                        str += 'kirimanKeys' + '=' + encodeURIComponent(element);
                    });
                }
                const url = `/${base_api_url}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                obj.totpaid= meta.totpaid;
                obj.totunpaid= meta.totunpaid;
                obj.totkirim = meta.totkirim;
                obj.kirtotal_val = meta.kirtotal_val;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`/${base_api_url}`,obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    update(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put(`/${base_api_url}`,obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    cekkiriman(obj) {
        return new Promise(async (resolve, reject) => {
            try {
               
                const {data} = await axios.post(`/${base_api_url}/cekkiriman`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    copykiriman(obj) {
        return new Promise(async (resolve, reject) => {
            try {
               
                const {data} = await axios.post(`/${base_api_url}/copykiriman`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    generate(obj) {
        return new Promise(async (resolve, reject) => {
            try {
               
                const {data} = await axios.post(`/${base_api_url}/generate`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    generateCancel(obj) {
        return new Promise(async (resolve, reject) => {
            try {
               
                const {data} = await axios.post(`/${base_api_url}/generatecancel`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/${base_api_url}/detail/${obj.kirimanKey}`);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detailGratis(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/korankirimangratis/detailgratis/${obj.kirimanKey}`);
                const list = data;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/${base_api_url}/${obj.kirimanKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise(async(resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir','customer_id', 'CustCode', 'CustName', 'inclsubagen', 'tgl1', 'tgl2', 'nofaktur', 'createby', 'kota_id', 'kota_name', 'area_id', 'area_name', 'kiriman_code','kiriman_name', 'kirimanKeys', 'jurusan_id', 'jurusan_name', 'salesae_id', 'salesae_name','paid'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                if(obj.kirimanKeys){
                    obj.kirimanKeys.forEach(element => {
                        str += str ? '&' : '?';
                        str += 'kirimanKeys' + '=' + encodeURIComponent(element);
                    });
                }

                const response = await axios({
                    url: `/${base_api_url}/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportrekapxls(obj = {}) {
        return new Promise(async(resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir','customer_id', 'CustCode', 'CustName', 'inclsubagen', 'tgl1', 'tgl2', 'nofaktur', 'createby', 'kota_id', 'kota_name', 'area_id', 'area_name', 'kiriman_code','kiriman_name', 'kirimanKeys', 'jurusan_id', 'jurusan_name', 'salesae_id', 'salesae_name','paid'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                if(obj.kirimanKeys){
                    obj.kirimanKeys.forEach(element => {
                        str += str ? '&' : '?';
                        str += 'kirimanKeys' + '=' + encodeURIComponent(element);
                    });
                }

                const response = await axios({
                    url: `/${base_api_url}/exportrekapxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
}